import moment from 'moment';
import { AccountData } from '../api';
import { useAuth } from '../session/InternalAuthProvider';
import { UseAuthPermissions } from '../session/UseAuthPermissions';

const LEFT_TO_RIGHT_ISOLATE_START = '⁦';
const POP_DIRECTIONAL_ISOLATE = '⁩';

export const isolateLtr = (text: string) => `${LEFT_TO_RIGHT_ISOLATE_START}${text}${POP_DIRECTIONAL_ISOLATE}`;

export const formatRefundCardSuffix = (cardSuffix?: string) => (cardSuffix ? isolateLtr(`•••• ${cardSuffix}`) : '');

export const formatRefundDate = (value: string | undefined, format: string) =>
  value ? isolateLtr(moment.utc(value).local().format(format)) : '';

export const useRefundAmountFormatter = () => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const { readOnly } = UseAuthPermissions();
  const locale = account.currency.toLowerCase() === 'ils' ? 'he-IL' : 'en-US';
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: account.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return (amount: number) => (readOnly ? '' : isolateLtr(formatter.format(amount)));
};
